import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { HelpersService } from '../../../services/tools/helpers.service';
import { ProveedoresService } from '../../../services/proveedores.service';
import { ObrasService } from '../../../services/obras.service';
import { ConceptosService } from '../../../services/conceptos.service';
import { CuentasPorPagarService } from '../../../services/cuentas-por-pagar.service';
import { CatalogoService } from '../../../services/tools/catalogos.service';
import { AutenticacionService, ModulosARK, TipoPermiso } from '../../../services/autenticacion.service';

@Component({
  selector: 'app-formulario-gasto',
  templateUrl: './formulario-gasto.component.html',
  styleUrls: ['./formulario-gasto.component.scss']
})
export class FormularioGastoComponent implements OnInit {
    @Output() gastoGuardado: EventEmitter<any> = new EventEmitter;
    @Output() accionCancelada: EventEmitter<any> = new EventEmitter;
    @Input() gastoSelected: number = null;

    public gasto: any = { activo: true };
    public esPeriodico: boolean = false;    

    //Base component
    public permitirEditarGasto: boolean = false;

    //helpers
    public errors: any = {}; 
    public catLoaded: any = { obras: false, proveedores: false, conceptos: false};
    public callbackAfterFullLoad: any = null;
    private isFullLoaded: boolean = false;

    //Combos
    public obras: any [] = [];
    public conceptos: any [] = [];
    public proveedores: any [] = [];
    public obraSelected: any = {};
    public proveedorSelected: any = {};
    public conceptoSelected: any = {};
    public loading_obras: boolean = false;
    public loading_proveedores: boolean = false;
    public loading_conceptos: boolean = false;
    public periodos: any[] = [];
    public periodicidadSelected: any = {};

    constructor(private obrasService: ObrasService,
      private conceptosService:ConceptosService,
      private proveedoresService: ProveedoresService,
      private gastosService: CuentasPorPagarService,
      private helperService: HelpersService,
      private catalogoService: CatalogoService,
      private authService: AutenticacionService) {
      }
      
    ngOnInit() {
      this.setupComponent();
    }

    ngOnChanges(changes: SimpleChanges) {
      if ( changes.gastoSelected ) {
        this.clearForm();
        if(this.gastoSelected){
          //Edit mode

          if(this.isFullLoaded){
            this.loadGasto(this.gastoSelected);
          }else{
            //Si aún no se han terminado de llenar los combos, se agrega un callback que se ejecute cuando estos se hayan llenado
            this.callbackAfterFullLoad = function (){
              this.loadGasto(this.gastoSelected);
            }
          }

        }
      }
    }

    private clearForm(){
      //Set default values
      this.errors = {}; 
      this.gasto = { activo: true };
      this.obraSelected = {};
      this.proveedorSelected = {};
      this.conceptoSelected = {};
      this.periodicidadSelected = {};
      this.esPeriodico = false;
    }

    private setupComponent(){
      this.loadObras();
      this.loadProveedores();
      this.loadConceptos();
      this.loadPeriodos();
      this.permitirEditarGasto = this.authService.tienenPermisos(ModulosARK.Gastos, TipoPermiso.Escritura);
    }

    public save(){
      this.errors = {};

      if(!this.esPeriodico){
        //Cuando un gasto no es periodico, su periodicidad y su fecha fin deben ser nulos
        this.gasto.periodicidad = null;
        this.gasto.fecha_fin = null;
      }
  
      this.errors = this.gastosService.validate(this.gasto);
  
      if (Object.entries(this.errors).length > 0) {
        return false;
      }
      
      if(this.gasto.id_gasto){
        //Acturalizar un gasto
        this.actualizarGasto(this.gasto);
      }else{
        //Crear un nuevo gasto
        this.crearGasto(this.gasto);
      }
    }

    private crearGasto(gasto){
      this.gastosService.create(gasto).subscribe(
        (response)=>
        {
          const result = response.json().content;
          this.helperService.notification('Gasto creado', 'Se ha registrado exitosamente el gasto', 'success');

          this.gastoGuardado.emit();
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          if(error.status == 400) {
            alert("ERROR: "+JSON.stringify(error));
          }
        }
      );
    }

    private actualizarGasto(gasto){
      this.gastosService.update(gasto).subscribe(
        (response)=>
        {
          const result = response.json().content;
          this.helperService.notification('Gasto actualizado', 'Se ha actualizado exitosamente el gasto', 'success');

          this.gastoGuardado.emit();
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          this.manejarErroresActualizacion(error);
        }
      );
    }

    private manejarErroresActualizacion(errorResponse){
      if(errorResponse.status == 400) {
        const result = errorResponse.json().content;
        if(result && result.general){
          let errors = [];
          errors["general"] = result.general;
          this.errors = errors;
        }else{
          alert("ERROR: "+JSON.stringify(errorResponse));
        }
      }
    }

    public cancel(){
      this.accionCancelada.emit();
    }

    public changePeriodicidad($event){
      this.periodicidadSelected = $event;
      this.gasto.periodicidad = $event.descripcion;
    }

    /**
     * Utilities
     */

    public changeObra($event){
      this.obraSelected = $event;
      this.gasto.id_obra = $event.idObras;
    }

    public changeProveedor($event){
      this.proveedorSelected = $event;
      this.gasto.id_proveedor = $event.idProveedores;
    }

    public changeConceptoSelected($event){
      this.conceptoSelected = $event;
      this.gasto.id_concepto = $event.idConceptos;
    }

    private loadObras(){
      this.loading_obras = true;
      this.obrasService.getObratoSelect('')
      .subscribe((response) => {
          this.obras = response.json().content;
          this.loading_obras = false;
          this.catLoaded.obras = true;
          this.checkIsFullLoaded();
      },error=>{
          alert("ERROR: "+JSON.stringify(error));
          this.loading_obras = false;
      });
    }

    private loadProveedores(){
        this.loading_proveedores = true;
        this.proveedoresService.getProveedorestoSelect()
        .subscribe(response => {
            let content = response.json().content;
            this.proveedores = content.proveedores;
            this.loading_proveedores = false;
            this.catLoaded.proveedores = true;
            this.checkIsFullLoaded();
        },error=>{
            alert("ERROR: "+JSON.stringify(error));
            this.loading_proveedores = false;
        });
    }

    private loadConceptos(){
      this.loading_conceptos = true;
      this.conceptosService.getAllConceptos()
      .subscribe(
        (response)=>{
          let content = response.json().content;
          this.conceptos = content;
          this.loading_conceptos = false;
          this.catLoaded.conceptos = true;
          this.checkIsFullLoaded();
        },
        (error)=>{
          this.loading_conceptos = false;
        }
      );
    }
    
    /**
     * Edit mode - functions
     */
    private loadPeriodos(){
      let periodos = this.catalogoService.getCatalogoPeriodos()

      //Selecciona el periodo default: Menual
      periodos.forEach(periodo => {
        if(periodo.default === true){
          this.changePeriodicidad(periodo);
        }
      });
      
      this.periodos = periodos;
    }

    private loadGasto(gastoId: number){
      this.gastosService.getGasto(gastoId)
      .subscribe((response) => {
        let gasto = response.json().content;
        this.gasto = gasto;
        this.selectObra(gasto.id_obra);
        this.selectProveedor(gasto.id_proveedor);
        this.selectConcepto(gasto.id_concepto);
        this.selectPeriodo(gasto.periodicidad);
      },error=>{
          alert("ERROR: "+JSON.stringify(error));
      });
    }

    private selectObra(id_obra: number){
      let component = this;
      this.obras.forEach(obra => {
        if(obra.idObras === id_obra){
          component.obraSelected = obra;         
        }
      });
    }

    private selectProveedor(id_proveedor: number){
      let component = this;
      this.proveedores.forEach(proveedor => {
        if(proveedor.idProveedores === id_proveedor){
          component.proveedorSelected = proveedor;         
        }
      });
    }

    private selectConcepto(id_concepto: number){
      let component = this;
      this.conceptos.forEach(concepto => {
        if(concepto.idConceptos === id_concepto){
          component.conceptoSelected = concepto;         
        }
      });
    }

    private selectPeriodo(periodo: string){
      let component = this;
      this.periodos.forEach(periodoItem => {
        if(periodoItem.descripcion == periodo){
          component.periodicidadSelected = periodoItem;  
          component.esPeriodico = true;       
        }
      });
    }

    private checkIsFullLoaded(){
      if(this.catLoaded.obras && this.catLoaded.proveedores 
        && this.catLoaded.conceptos){
          //Cuando el formulario esta en modo edición, requiere que se hayan cargado todos los combos
          //para poder llenar adecuadamente los campos del gasto que se va a editar
          this.isFullLoaded = true;
          if(this.callbackAfterFullLoad){
            this.callbackAfterFullLoad();
          }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/gastos/formulario-gasto/formulario-gasto.component.ts